import React from "react";
import PropTypes from "prop-types";
import { BottomSheet } from "@cars24/turbo-web/lib/bottom-sheet";
import { Modal } from "@cars24/turbo-web/lib/modal";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const PostInspectionDiyModal = ({
    isMobile,
    children,
    height = "auto",
    width = "420px",
    onClose = () => { },
    showCloseButton = true,
    id = "portal",
    defaultPadding = true
}) => {
    const { tokens } = useTokens();
    const backgroundOverlay = tokens.background_surface_overlay_primary;

    return (
        <React.Fragment>
            {isMobile ?
                <BottomSheet
                    overlayColor={backgroundOverlay}
                    height={height}
                    onClose={onClose}
                    isOpen
                    showCloseButton={showCloseButton}
                    id={id}
                    defaultPadding={defaultPadding}
                >{children}</BottomSheet> :
                <Modal
                    height={height}
                    isOpen
                    onClose={onClose}
                    width={width}
                    overlayColor={backgroundOverlay}
                    showCloseButton={showCloseButton}
                    id={id}
                >
                    {children}</Modal>}
        </React.Fragment>
    );
};

PostInspectionDiyModal.propTypes = {
    isMobile: PropTypes.bool,
    height: PropTypes.string,
    width: PropTypes.string,
    onClose: PropTypes.func,
    children: PropTypes.any,
    showCloseButton: PropTypes.bool,
    id: PropTypes.string,
    defaultPadding: PropTypes.bool
};

export default PostInspectionDiyModal;
